import { render, staticRenderFns } from "./SeoPagination.vue?vue&type=template&id=3005b3b0&"
import script from "./SeoPagination.vue?vue&type=script&lang=js&"
export * from "./SeoPagination.vue?vue&type=script&lang=js&"
import style0 from "./SeoPagination.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports